export async function handleResponse(response) {
	console.log("🚀 ~ file: apiUtils.js ~ line 2 ~ handleResponse ~ response", response);
	if (response.status == 200 || response.status == 201) return response.data.data?response.data.data:response.data.new;

	throw new Error(response.statusText);
}

// In a real app, would likely call an error logging service.
export function handleError(error) {
	// eslint-disable-next-line no-console
	console.error("API call failed. " + error);
	throw error;
}
